document.addEventListener("DOMContentLoaded", () => {
  if (!window.AOS) return;

  AOS.init({
    duration: 700,
    easing: "ease",
    once: true,
    offset: 80,
  });
});

document.addEventListener("shopify:section:load", () => {
  if (window.AOS) AOS.refreshHard();
});
